import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./contexts/AuthContext/AuthContext";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import Home from "./pages/Home";
import SignInPage from "./components/SignInPage/SignInPage";
import RegisterPage from "./components/RegisterPage/RegisterPage";
import ActivatePage from "./components/ActivatePage/ActivatePage";
import ResetPasswordConfirmPage from "./components/ResetPasswordConfirmPage/ResetPasswordConfirmPage";
import TranslationOrder from "./components/TranslationOrder/TranslationOrder";
import InitialOrderSuccess from "./components/InitialOrderSuccess/InitialOrderSuccess";
import MyOrders from "./components/MyOrders/MyOrders";
import OrderPayment from "./components/OrderPayment/OrderPayment";
import PaymentSuccess from "./components/PaymentSuccess/PaymentSuccess";
import Contact from "./components/Contact/Contact";
import About from "./components/About/About";
import Demos from "./components/Demos/Demos";
import News from "./components/NewsPage/News";
import SettingsPage from "./components/SettingsPage/SettingsPage";
import { LanguageProvider } from "./contexts/LanguageContext/LanguageContext";
import { MonetizationProvider } from "./contexts/MonetizationContext/MonetizationContext";
import usePageTracking from "./usePageTracking"; // Adjust path as needed

const Layout = ({ children }) => (
  <div className="flex flex-col min-h-screen">
    <Navbar />
    <main className="flex-grow">{children}</main>
    <Footer />
  </div>
);

const AppContent = () => {
  usePageTracking();
  return (
    <AuthProvider>
      <LanguageProvider>
        <MonetizationProvider>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/signin" element={<SignInPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/activate/:uid/:token" element={<ActivatePage />} />
              <Route
                path="/reset-password-confirm/:uid/:token"
                element={<ResetPasswordConfirmPage />}
              />
              <Route
                path="/initial-translation-order"
                element={<TranslationOrder />}
              />
              <Route
                path="/initial-order-success"
                element={<InitialOrderSuccess />}
              />
              <Route
                path="/order-payment/:orderId"
                element={<OrderPayment />}
              />
              <Route path="/my-orders" element={<MyOrders />} />
              <Route
                path="/payment-confirmation-page/:orderId/success"
                element={<PaymentSuccess />}
              />
              <Route path="/contact" element={<Contact />} />
              <Route path="/about" element={<About />} />
              <Route
                path="/demos"
                element={
                  <Demos demosConfigPath="/DemosReelConfigMulti/demosConfigMulti.json" />
                }
              />
              <Route path="/news" element={<News />} />
              <Route path="/settings" element={<SettingsPage />} />
            </Routes>
          </Layout>
        </MonetizationProvider>
      </LanguageProvider>
    </AuthProvider>
  );
};

const App = () => (
  <HelmetProvider>
    <Router>
      <AppContent />
    </Router>
  </HelmetProvider>
);

export default App;
